/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioHierarchyResponse extends models.AppSecopsPortfolio {
    getFixupPrototypeFunction() { return AppSecopsPortfolioHierarchyResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioHierarchyResponse>): AppSecopsPortfolioHierarchyResponse {
        let obj = Object.assign(new AppSecopsPortfolioHierarchyResponse(), model);
        AppSecopsPortfolioHierarchyResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioHierarchyResponse>): AppSecopsPortfolioHierarchyResponse {
        if (!model) return null;
        return AppSecopsPortfolioHierarchyResponse.newInstance(<AppSecopsPortfolioHierarchyResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioHierarchyResponse) {
        if (!obj) return;

        models.AppSecopsPortfolioHierarchyResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioHierarchyResponse): boolean {
        if (models.AppSecopsPortfolio.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioHierarchyResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.applications) {
            for (let val of this.applications) {
                models.AppSecopsDashboardApplicationDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * The application details associated with the portfolio
     */
    applications: Array<models.AppSecopsDashboardApplicationDetails>;

}
